module.exports = __webpack_public_path__ + "static/0-742e0ff15cee4619b0df8cd0ce14bc93.png";